import { cx } from '@emotion/css';

import { useBreakpoints } from '@phoenix/design-system/frontend/ui/breakpoints/use-breakpoints';

import { useClosestBaseUrlIndex } from '../../../util/links/path.util';
import { useNavigation } from '../context/navigation-context-provider';
import { useOutsideClick } from '../hooks/useOutsideClick';
import { NavigationItem } from './navigation-item';
import { useTranslation } from 'next-i18next';

export const HorizontalNavigation = () => {
  const { t } = useTranslation();
  const { config, setState } = useNavigation();
  const activeNavItemIndex = useClosestBaseUrlIndex(config.mainNavItems?.map(({ url }) => url));
  const { md } = useBreakpoints();
  const outsideRef = useOutsideClick(() => {
    setState?.((s) => ({
      ...s,
      showDesktopSubMenu: null,
      showBackdrop: false,
    }));
  });

  if (!md && !config.name) {
    return null;
  }

  return (
    <div className={cx('flex flex-1 border-b border-secondary-mid bg-primary-white', config.mainNavItems && 'md:h-[3.625rem]')}>
      <div className={cx('relative flex h-[2.375rem] flex-1 items-center gap-4', config.mainNavItems ? 'md:h-[3.625rem]' : 'md:hidden')}>
        <nav className="stihl-page-container-grid w-full" aria-label={t('shared:shared_globalNav_desktop_aria_label')}>
          <div className="w-full" />
          <div className="col-span-3 flex items-center md:col-span-2 [@media(min-width:530px)]:col-start-2">
            {config.name && (
              <div className={cx('pl-3 pr-12 stihl-text-highlight-flag md:stihl-text-highlight-price-sm')}>{config.name.toUpperCase()}</div>
            )}
            <ul className="z-10 hidden h-[2.375rem] md:flex md:h-[3.625rem]" ref={outsideRef}>
              {config.mainNavItems?.map((item, index) => (
                <NavigationItem key={item.id} item={item} index={index} isActiveRoute={index === activeNavItemIndex} />
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};
